import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ClipboardX } from 'lucide-react';
import { TranslationNS } from '@gokrew/models/constants';
import EmptyState from '@/components/TableEmptyState';
import styles from './MyTeamAccessLost.module.css';

/**
 * Shown in place of the Approvals inbox to someone who is no longer a
 * manager or a delegate (their last report moved, their delegation ended, or
 * manager access was turned off) arriving from an approval link
 * (`?request=`) in an email, Slack, Teams or a notification. Says why instead
 * of silently landing them elsewhere. Any other manager-only My team URL just
 * opens their Team tab (`MyTeamGuard`). The access probe never errors, so
 * nothing else reports this: no toast.
 */
export const MyTeamAccessLost = ({ fallback }: { fallback: string }) => {
  const { t } = useTranslation(TranslationNS.MyTeam);
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <EmptyState
        Icon={ClipboardX}
        title={t('access_lost.request_title')}
        message={t('access_lost.request_description')}
        ctaLabel={t('access_lost.cta')}
        onCtaClick={() => navigate(fallback, { replace: true })}
      />
    </div>
  );
};
